import React, { useState } from 'react'
import PublisherCard from '@Components/ViewWork/PublisherCard'
import './index.scss'
import clsx from 'clsx'
import { ZodFormattedError } from 'zod'
import { Maybe } from '@Types'
import { WorkType } from '@Components/ViewWork/work-type'
import { RightsholderContact } from '@Entities/rightsholder/rightsholder-contact'
import { PublisherModel } from '@Entities/work/publisher-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

interface PublisherComponentProps {
    publisher: OriginalPublisherModel
    publisherError?: ZodFormattedError<OriginalPublisherModel>
    admin?: PublisherModel
    adminPublisherError?: ZodFormattedError<PublisherModel>
    publicContact?: Maybe<RightsholderContact>
    workType?: WorkType
}

const PublisherComponent = (props: PublisherComponentProps) => {
    const { publisher, publisherError, admin, adminPublisherError, publicContact, workType } = props
    const primary = admin ?? publisher
    const primaryError = adminPublisherError ?? publisherError

    const [isExpanded, setIsExpanded] = useState(true)

    return (
        <div className={clsx('publisher-component', isExpanded && 'expanded')}>
            <PublisherCard
                publisher={primary}
                isExpanded={isExpanded}
                toggleExpanded={() => setIsExpanded(!isExpanded)}
                publicContact={publicContact}
                errors={primaryError}
                workType={workType}
            />

            {admin && (
                <div className="sub-publisher-component">
                    <div className="svg-container">
                        <svg
                            aria-hidden="true"
                            role="img"
                            focusable="false"
                            aria-labelledby="title"
                            data-testid="connector-svg"
                            viewBox="0, 0, 30, 71"
                            preserveAspectRatio="none"
                        >
                            <title>Admin Original Publisher Connecting Line</title>
                            <line
                                vectorEffect="non-scaling-stroke"
                                x1={20}
                                x2={20}
                                y1={0}
                                y2={70}
                                stroke="#BDBDBD"
                                strokeLinecap="square"
                            />
                            <line
                                vectorEffect="non-scaling-stroke"
                                x1={20}
                                x2={30}
                                y1={70}
                                y2={70}
                                stroke="#BDBDBD"
                                strokeLinecap="square"
                            />
                        </svg>
                    </div>
                    <PublisherCard publisher={publisher} errors={publisherError} isSubPublisher />
                </div>
            )}
        </div>
    )
}

export default PublisherComponent
